module.exports = [{"name":"ינואר","articleVignetteId":5647199},{"name":"פברואר","articleVignetteId":5647200},{"name":"מרץ","articleVignetteId":5647201},{"name":"אפריל","articleVignetteId":5647203},{"name":"מאי","articleVignetteId":5647204},{"name":"יוני","articleVignetteId":5647205},{"name":"יולי","articleVignetteId":5647206},{"name":"אוגוסט","articleVignetteId":5647207},{"name":"ספטמבר","articleVignetteId":5647208},{"name":"אוקטובר","articleVignetteId":5647209},{"name":"נובמבר","articleVignetteId":5647212},{"name":"דצמבר","articleVignetteId":5647213}]


//////////////////
// WEBPACK FOOTER
// ./src/static/api/data.json
// module id = 31
// module chunks = 0